import { render, staticRenderFns } from "./MailboxSecurityView.vue?vue&type=template&id=94241a7e&"
import script from "./MailboxSecurityView.vue?vue&type=script&lang=js&"
export * from "./MailboxSecurityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94241a7e')) {
      api.createRecord('94241a7e', component.options)
    } else {
      api.reload('94241a7e', component.options)
    }
    module.hot.accept("./MailboxSecurityView.vue?vue&type=template&id=94241a7e&", function () {
      api.rerender('94241a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/mailbox/MailboxSecurityView.vue"
export default component.exports